import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { align: "center" }
const _hoisted_3 = { class: "text-subtitle-1 text-medium-emphasis" }
const _hoisted_4 = { class: "text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between" }

import { computed, ref } from 'vue'
import { doctorAuthStore } from '../../../../stores/doctor-auth'
import { useI18n } from 'vue-i18n'
import HeaderComponent from '@/components/Header/HeaderComponent.vue'
import router from '@/router'
import { useMeta } from 'vue-meta'
import FooterComponent from '@/components/Footer/FooterComponent.vue'
import { hospitalAuthStore } from '@/stores/hospital-auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalLogin',
  setup(__props) {

const { t } = useI18n()
const email = ref<string>('')
const password = ref<string>('')
const visible = ref(false)
const isLoading = ref(false)
const responseStatus = ref({})

const emailRules = [
  (v: string) => !!v || t('email-required'),
  (v: string) => /.+@.+\..+/.test(v) || t('email-authentic'),
]

const passwordRules = [(v: string) => !!v || t('password-required')]

const isInfoCompleted = computed(() => {
  const isEmailInvalid = emailRules.some((rule) => {
    const result = rule(email.value)
    return typeof result === 'string'
  })
  const isPasswordInValid = passwordRules.some((rule) => {
    const result = rule(password.value)
    return typeof result === 'string'
  })

  return (
    email.value != '' &&
    password.value != '' &&
    !isPasswordInValid &&
    !isEmailInvalid
  )
})

useMeta(
  computed(() => ({
    title: 'Medcircle',
  }))
)

const login = async () => {
  isLoading.value = true
  const hospitalAuth = hospitalAuthStore()
  const credentials = {
    email: email.value,
    password: password.value,
  }

  const response = await hospitalAuth.login(credentials)
  responseStatus.value = response

  if (response.success) {
    localStorage.setItem('hospitalAccessToken', response?.result?.token)
    hospitalAuth.isAuthenticated = true
    await router.push('/hospital-dashboard')
  }
  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeaderComponent),
      _createVNode(_component_request_status, {
        response: responseStatus.value,
        isLoading: false
      }, null, 8, ["response"]),
      _createElementVNode("div", null, [
        _createVNode(_component_v_card, {
          class: "mx-auto pa-12 pb-8 my-10",
          elevation: "8",
          "max-width": "448",
          rounded: "lg"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_img, {
                width: "100px",
                src: require('../../../../assets/hospital.png')
              }, null, 8, ["src"])
            ]),
            _createVNode(_component_v_card_title, {
              align: "center",
              class: "mb-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('hospital.login')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('account')), 1),
            _createVNode(_component_v_text_field, {
              modelValue: email.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
              density: "compact",
              placeholder: _ctx.$t('email'),
              "prepend-inner-icon": "mdi-email-outline",
              rules: emailRules,
              variant: "outlined",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (isInfoCompleted.value ? login() : undefined), ["enter"]))
            }, null, 8, ["modelValue", "placeholder"]),
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.$t('password')) + " ", 1),
              _createElementVNode("a", {
                class: "text-caption text-decoration-none text-blue",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/hospital-forgot-password'))),
                style: {"cursor":"pointer"}
              }, _toDisplayString(_ctx.$t('forgot-password')), 1)
            ]),
            _createVNode(_component_v_text_field, {
              modelValue: password.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((password).value = $event)),
              "append-inner-icon": visible.value ? 'mdi-eye-off' : 'mdi-eye',
              type: visible.value ? 'text' : 'password',
              density: "compact",
              placeholder: _ctx.$t('enter-password'),
              "prepend-inner-icon": "mdi-lock-outline",
              variant: "outlined",
              rules: passwordRules,
              "onClick:appendInner": _cache[4] || (_cache[4] = ($event: any) => (visible.value = !visible.value)),
              onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (isInfoCompleted.value ? login() : undefined), ["enter"]))
            }, null, 8, ["modelValue", "append-inner-icon", "type", "placeholder"]),
            _createVNode(_component_v_btn, {
              class: "mb-8",
              color: "blue",
              size: "large",
              variant: "flat",
              block: "",
              loading: isLoading.value,
              disabled: !isInfoCompleted.value,
              onClick: login
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login')), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"]),
            _createVNode(_component_v_card_text, { class: "text-center" }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  class: "text-blue text-decoration-none",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push('/hospital-register'))),
                  style: {"cursor":"pointer"}
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('register')), 1),
                  _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})